export default __webpack_public_path__ + "static/media/bridgeT_online.4f36cb8a.svg";